import PieChart from "@arelia-components/ui-atoms/PieChart";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Card, CardContent, CardHeader } from "@mui/material";

type Props = {
  isLoading: boolean;
  breakdown: {label: string, value: number}[];
  onItemClick: (type: string) => void
};

export default function RoyaltiesBreakdown({ isLoading, breakdown, onItemClick }: Props) {
  return <Card sx={styles.card}>
    <CardHeader
      title="Royalties Breakdown"
    />
    <SpinnerWrapper loading={isLoading}>
      <CardContent>
        <PieChart<number>
          data={breakdown}
          title="Royalties Breakdown"
          onDataClick={data => onItemClick(data.label)}
        />
      </CardContent>
    </SpinnerWrapper>
  </Card>;
}

const styles = {
  card: {
    gridColumn: "span 6",
    gridRow: "span 6"
  }
};